import {
  commitTextEdit,
  placeTextLayer,
  startEditingTextLayer,
  topTextLayerAt,
} from '../state/textActions';
import { getTextEditSession } from '../state/textEdit';
import type { Tool, ToolPointerEvent } from './types';

/**
 * Place/edit on pointer-up so the mouseup that ends the click cannot blur the
 * new textarea and immediately discard an empty layer.
 */
export const typeTool: Tool = {
  id: 'type',
  cursor: 'text',
  snaps: true,
  hint: 'Click to type; Ctrl+Enter commits',

  onPointerUp(event: ToolPointerEvent, ctx) {
    if (event.button !== 0) return;

    if (getTextEditSession()) {
      commitTextEdit();
    }

    const existing = topTextLayerAt(event.point);
    if (existing) {
      startEditingTextLayer(existing.id);
      ctx.setStatus('Editing text — Ctrl+Enter to commit');
      return;
    }
    placeTextLayer(event.point);
    ctx.setStatus('Type to enter text — Ctrl+Enter to commit');
  },

  onKeyDown(event) {
    if (!getTextEditSession()) return false;
    if (event.key === 'Escape') {
      commitTextEdit();
      return true;
    }
    if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
      commitTextEdit();
      return true;
    }
    return false;
  },

  cancel() {
    if (getTextEditSession()) commitTextEdit();
  },
};
